import React from "react";
import logo from "../images/WhiteQFPLogo.png";
import logo2 from "../images/Logos/Model Q/Q-Financial Logo Transparent - Horizontal.png";
function TopBar(props) {
  const weblogo = props.logo === undefined ? "" : props.logo.website;
  // console.log("props.logo :>> ", props.logo);
  // console.log("weblogo :>> ", weblogo);

  return (
    <div className="topbar">
      {window.location.href.includes("test") ? (
        <div className="testText">Test Mode</div>
      ) : (
        //  <img src={logo2} className="logo" alt="logo" />
        <img src={weblogo} className="logo" alt="logo" />
      )}
    </div>
  );
}

export default TopBar;
